import { __awaiter } from '../../_virtual/_tslib.js';
import { getWebVitals } from '../utils/performance.js';
import { _techReportPb } from './new-report.js';
import { options } from './option.js';
import { _global, handlerFilter, handlerFilterUa, getSampling, getErrorId } from '../utils/unils.js';
import { handleJsError, handleResourceError, handlerRejection } from './error.js';
import { mirrorPluginsIns } from './handlePlugin.js';
import { EVENTTYPES } from '../utils/enum.js';
import { HandlerUserReplace } from './handleReplace.js';

const ERROR_ID = [];
// 是否上报过同类型错误的id
const getIsReportId = error => {
    const id = getErrorId((error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.fileName));
    const even = item => item === id;
    if (ERROR_ID.some(even)) {
        console.warn(`Duplicate error, not reported,${error === null || error === void 0 ? void 0 : error.message}`);
        return false;
    }
    else {
        ERROR_ID.push(id);
        return true;
    }
};
// 统一处理事件
const HandleEvents = {
    // js&&resource error
    handleError(ev) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function* () {
            // 浏览器视口小于100不上报
            if ((_global === null || _global === void 0 ? void 0 : _global.screen.width) <= 100 || _global.screen.height <= 100)
                return;
            if ((_global === null || _global === void 0 ? void 0 : _global.innerWidth) <= 100 || _global.innerHeight <= 100)
                return;
            const target = ev.target;
            try {
                if (!target || (ev.target && !ev.target.localName)) {
                    // js错误上报 -过滤配置
                    const errorData_js = handleJsError(ev);
                    const filterList = (_b = (_a = options === null || options === void 0 ? void 0 : options.config) === null || _a === void 0 ? void 0 : _a.white) === null || _b === void 0 ? void 0 : _b.error;
                    const isFilterEndJs = ((_c = options === null || options === void 0 ? void 0 : options.config) === null || _c === void 0 ? void 0 : _c['filter-end-js']) || false;
                    const isFilter = handlerFilter(errorData_js, filterList, isFilterEndJs);
                    const isFilterUa = handlerFilterUa((_e = (_d = options === null || options === void 0 ? void 0 : options.config) === null || _d === void 0 ? void 0 : _d.white) === null || _e === void 0 ? void 0 : _e.ua);
                    // ua命中过滤,不上报
                    if (isFilterUa)
                        return;
                    // 对应配置过滤
                    if (!isFilter) {
                        // 唯一id判断
                        if (!getIsReportId(errorData_js))
                            return;
                        // js错误-before，插件注入
                        const pluginJsErrorRes = yield mirrorPluginsIns.before(EVENTTYPES.ERROR, errorData_js);
                        if (!pluginJsErrorRes)
                            return;
                        _techReportPb({
                            type: 'error',
                            eventId: `${options.origin}.${options.module}.ERROR.jsError`,
                            msg: errorData_js
                        }, options.pbOptions || {});
                        // 行为日志
                        HandlerUserReplace.jsErrorReplace(errorData_js);
                        // js错误-after
                        mirrorPluginsIns.after(EVENTTYPES.ERROR, errorData_js);
                    }
                }
                if (target === null || target === void 0 ? void 0 : target.localName) {
                    // 资源加载报错上报 -过滤配置
                    let errorData_resource = handleResourceError(ev);
                    // 如果资源目标为空则过滤
                    if (!errorData_resource || !errorData_resource.message.trim().length)
                        return;
                    const filterListResource = (_g = (_f = options === null || options === void 0 ? void 0 : options.config) === null || _f === void 0 ? void 0 : _f.white) === null || _g === void 0 ? void 0 : _g.resource;
                    const isFilterResource = handlerFilter(errorData_resource, filterListResource);
                    const isFilterUa = handlerFilterUa((_j = (_h = options === null || options === void 0 ? void 0 : options.config) === null || _h === void 0 ? void 0 : _h.white) === null || _j === void 0 ? void 0 : _j.ua);
                    // ua命中过滤,不上报
                    if (isFilterUa)
                        return;
                    // 对应配置过滤
                    if (!isFilterResource) {
                        // 唯一id判断
                        if (!getIsReportId(errorData_resource))
                            return;
                        // resource -before，插件注入
                        const pluginResourceErrorRes = yield mirrorPluginsIns.before(EVENTTYPES.RESOURCE, errorData_resource);
                        if (!pluginResourceErrorRes)
                            return;
                        _techReportPb({
                            type: 'error',
                            eventId: `${options.origin}.${options.module}.ERROR.resourceError`,
                            msg: Object.assign(Object.assign({}, errorData_resource), { error_type: 'AssetsError', headless: navigator.language == '' ? 'headless' : 'normal', webdriver: navigator === null || navigator === void 0 ? void 0 : navigator.webdriver })
                        }, options.pbOptions || {});
                        // 行为日志
                        HandlerUserReplace.resourceErrorReplace(errorData_resource);
                        // resource-after
                        mirrorPluginsIns.after(EVENTTYPES.RESOURCE, errorData_resource);
                    }
                }
            }
            catch (error) {
                console.warn('bili-mirror: handleError-Error parsing failed:', error);
            }
        });
    },
    // 异步错误
    unhandRejection(ev) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // 浏览器视口小于100不上报
                if ((_global === null || _global === void 0 ? void 0 : _global.screen.width) <= 100 || _global.screen.height <= 100)
                    return;
                if ((_global === null || _global === void 0 ? void 0 : _global.innerWidth) <= 100 || _global.innerHeight <= 100)
                    return;
                const errorData_rejection = handlerRejection(ev);
                const filterListRejection = (_b = (_a = options === null || options === void 0 ? void 0 : options.config) === null || _a === void 0 ? void 0 : _a.white) === null || _b === void 0 ? void 0 : _b.rejection;
                const isFilterEndJs = ((_c = options === null || options === void 0 ? void 0 : options.config) === null || _c === void 0 ? void 0 : _c['filter-end-js']) || false;
                const isFilterRejection = handlerFilter(errorData_rejection, filterListRejection, isFilterEndJs);
                const isFilterUa = handlerFilterUa((_e = (_d = options === null || options === void 0 ? void 0 : options.config) === null || _d === void 0 ? void 0 : _d.white) === null || _e === void 0 ? void 0 : _e.ua);
                // ua命中过滤,不上报
                if (isFilterUa)
                    return;
                if (!isFilterRejection) {
                    if (!getIsReportId(errorData_rejection))
                        return;
                    // promise错误-before，插件注入
                    const pluginPromiseErrorRes = yield mirrorPluginsIns.before(EVENTTYPES.UNHANDLEDREJECTION, errorData_rejection);
                    if (!pluginPromiseErrorRes)
                        return;
                    _techReportPb({
                        type: 'error',
                        eventId: `${options.origin}.${options.module}.ERROR.rejectionError`,
                        msg: errorData_rejection
                    }, options.pbOptions || {});
                    // 行为日志
                    HandlerUserReplace.promiseErrorReplace(errorData_rejection);
                    // promise -after
                    mirrorPluginsIns.after(EVENTTYPES.UNHANDLEDREJECTION, errorData_rejection);
                }
            }
            catch (error) {
                console.warn('bili-mirror: unhandRejection-Error parsing failed:', error);
            }
        });
    },
    // 性能处理模块
    handlePerformance() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!PerformanceObserver || !(PerformanceObserver === null || PerformanceObserver === void 0 ? void 0 : PerformanceObserver.supportedEntryTypes))
                    return;
                const baseValue = options.config['white-performance-rate'];
                if (getSampling(baseValue))
                    return;
                getWebVitals((res) => __awaiter(this, void 0, void 0, function* () {
                    // name指标名称、rating 评级、value数值
                    let { name, value } = res;
                    // safari部分性能获取到负数，过滤
                    if (!value || value < 0)
                        return;
                    // performance 插件注入 before
                    const pluginPerformanceRes = yield mirrorPluginsIns.before(EVENTTYPES.PERFORMANCE, res);
                    if (!pluginPerformanceRes)
                        return;
                    _techReportPb({
                        type: 'performance',
                        eventId: `${options.origin}.${options.module}.PERFORMANCE.${res.name}`,
                        //如果是PAGETIME上报页面整体瀑布流时间否则基于标准值上报
                        msg: name === 'PAGETIME' ? Object.assign({}, res === null || res === void 0 ? void 0 : res.data) : Object.assign({}, res)
                    }, options.pbOptions || {});
                    // 插件after
                    mirrorPluginsIns.after(EVENTTYPES.PERFORMANCE, res);
                }));
            }
            catch (error) {
                console.warn('bili-mirror: performance-Error parsing failed:', error);
            }
        });
    }
};

export { HandleEvents };
